// extracted by mini-css-extract-plugin
export default {"container":"Process_container__jyl28","card":"Process_card__jHCfw","small":"Process_small__Kp8VU","text":"Process_text__IjTxw","newBtn":"Process_newBtn__XmecS"};